import React from "react";
import styles from "./loading-indicator.module.scss";

const LoadingIndicator: React.FC = () => {
  return (
    <div className={styles.loader}>
      <div className={styles.logo} />
      <div className={styles.dotBlock}>
        {Array.from({ length: 6 }, (_, i) => (
          <div key={i} className={styles.dot} />
        ))}
      </div>
    </div>
  );
};

export default LoadingIndicator;
